export default "__VITE_ASSET__BO$akyFY__"